import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, Subscription } from 'rxjs';
import { NavigationService } from 'src/app/services/navigation.service';
import { SessionService } from 'src/app/services/session.service';
import { getStaticDashboardById } from './static-dashboard.config';

@Component({
  selector: 'app-static-dashboard-embed',
  templateUrl: './static-dashboard-embed.component.html',
  styleUrls: ['./static-dashboard-embed.component.scss'],
})
export class StaticDashboardEmbedComponent implements OnInit, OnDestroy {
  pageTitle = 'Static Dashboard';
  clientLogo: any;
  newColor: any;
  iframeSrc: SafeResourceUrl | null = null;

  private moduleName = '';
  private clientKey: string | null = null;
  private moduleKey: string | null = null;
  private subscriptions: Subscription[] = [];

  constructor(
    private readonly route: ActivatedRoute,
    private readonly navigationService: NavigationService,
    private readonly sessionService: SessionService,
    private readonly sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.clientLogo = this.sessionService.getClintLogo();
    this.newColor = this.sessionService.getColorCodes();

    this.subscriptions.push(
      combineLatest([this.route.params, this.route.queryParams]).subscribe(
        ([params, queryParams]) => {
          this.moduleName = params['module'] ?? '';
          const dashboardId = params['dashboardId'] ?? '';
          const decrypted = this.navigationService.decryptData(queryParams);
          this.clientKey = decrypted['cl_key'] ?? null;
          this.moduleKey = decrypted['md_key'] ?? null;

          const definition = getStaticDashboardById(dashboardId);
          if (!definition) {
            this.navigateToModuleLanding();
            return;
          }

          this.pageTitle = definition.title;
          this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
            definition.assetPath
          );
        }
      )
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  private navigateToModuleLanding(): void {
    const query: Record<string, string> = {};
    if (this.clientKey) {
      query['cl_key'] = this.clientKey;
    }
    if (this.moduleKey) {
      query['md_key'] = this.moduleKey;
    }
    this.navigationService.routerNavigate(`dashboard/${this.moduleName}`, query);
  }
}
